import React, { useState } from "react";
import {
  getAuth,
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { db, auth, provider } from "../firebase/fireabase";
import { doc, setDoc } from "firebase/firestore";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { BiLogoGoogle } from "react-icons/bi";
import { Link } from "react-router-dom";

import Login from "./Login";
const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [name, setName] = useState(""); // Add this line
  const [phoneNumber, setPhoneNumber] = useState(""); // Add this line
  const [username, setUsername] = useState(""); // Add this line
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (event, setState) => {
    setState(event.target.value);
  };

  // handel singup using facebook
  const handleSignUpWithFacebook = () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        // The signed-in user info.
        const user = result.user;
        console.log(user, "user data");
        // access user token and fetch user data
        const credential = FacebookAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        fetch(
          `https://graph.facebook.com/v11.0/me?fields=id,name,email,picture&access_token=${token}`
        )
          .catch((error) => {
            console.log(error);
          })
          .then((response) => {
            response.json().then((data) => {
              console.log(data, "facebook data");
              // Add the user to the "users" collection in Firestore
              setDoc(doc(db, "users", user.uid), {
                name: data.name,
                email: data.email || user.email,
                phoneNumber: user.phoneNumber,
                photoURL: data.picture.data.url,
                craetedAt: new Date().toISOString(),
              });

              localStorage.setItem("user", JSON.stringify(user));
              navigate("/", { replace: true });
            });
          });
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        setError(errorMessage);
      });
  };

  const handleReset = () => {
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setName(""); // Add this line
    setPhoneNumber(""); // Add this line
    setUsername(""); // Add this line
    setError("");
  };

  // ...

  const handleSubmit = (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
    } else {
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;

          // Add additional user information to Firestore
          setDoc(doc(db, "users", user.uid), {
            email: email,
            name: name,
            phoneNumber: phoneNumber,
            username: username,
          });

          localStorage.setItem("user", JSON.stringify(user));
          setError("");
          handleReset();
          navigate("/myprofile/" + user.uid, { replace: true });
        })
        .catch((error) => {
          const errorMessage = error.message;
          setError(errorMessage);
        });
    }
  };

  const handleSignUpWithGoogle = () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();

    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        const user = result.user;

        // Add the user to the "users" collection in Firestore
        setDoc(doc(db, "users", user.uid), {
          name: user.displayName,
          email: user.email,
          phoneNumber: user.phoneNumber,
          photoURL: user.photoURL,
        });

        localStorage.setItem("user", JSON.stringify(user));
        navigate("/", { replace: true });
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        setError(errorMessage);
      });
  };

  return (
    <React.Fragment>
      <Login
        email={email}
        password={password}
        setEmail={setEmail}
        setPassword={setPassword}
        handleLogin={handleSubmit}
        handleLoginWithGoogle={handleSignUpWithGoogle}
        error={error}
        signup={true}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        name={name}
        setName={setName}
        facebookSignup={handleSignUpWithFacebook}
      />
    </React.Fragment>
  );
};

export default SignUp;
